// extracted by mini-css-extract-plugin
module.exports = {"headerHeight":"80px"};